import { createContext, useContext } from "react";

import { type PaywallConfig } from "./config-context";

interface PaywallContextType {
  isPaywallEligible: boolean;
  paywallConfig: PaywallConfig;
}

const PaywallContext = createContext<PaywallContextType | null>(null);

export const usePaywall = (): PaywallContextType => {
  const paywallContext = useContext(PaywallContext);

  if (!paywallContext) {
    throw new Error("Missing Paywall Context");
  }

  return paywallContext;
};

export default PaywallContext;
